document.addEventListener("DOMContentLoaded", function () {


  /* =====================================================
     MENÚ GLOBAL
     ===================================================== */

  const menuToggle = document.querySelector(".menu-toggle");
  const mobileMenu = document.querySelector(".mobile-menu");

  if (menuToggle && mobileMenu) {
    const closeMenu = function () {
      mobileMenu.setAttribute("aria-hidden", "true");
      mobileMenu.classList.remove("open");
      menuToggle.setAttribute("aria-expanded", "false");
    };
    const openMenu = function () {
      mobileMenu.setAttribute("aria-hidden", "false");
      mobileMenu.classList.add("open");
      menuToggle.setAttribute("aria-expanded", "true");
    };
    menuToggle.addEventListener("click", function (event) {
      event.stopPropagation();
      if (mobileMenu.getAttribute("aria-hidden") === "false") closeMenu(); else openMenu();
    });
    mobileMenu.querySelectorAll("a").forEach(function (link) { link.addEventListener("click", closeMenu); });
    document.addEventListener("click", function (event) {
      if (mobileMenu.getAttribute("aria-hidden") === "false" && !mobileMenu.contains(event.target) && !menuToggle.contains(event.target)) closeMenu();
    });
    document.addEventListener("keydown", function (event) { if (event.key === "Escape") closeMenu(); });
  }

  /* =====================================================
     HEADER DINÁMICO
     ===================================================== */

  const header =
    document.querySelector(".header");


  if (header) {

    let lastScrollY =
      window.scrollY;

    let ticking = false;

    const scrollTolerance = 5;


    function updateHeader() {

      header.classList.remove("header-hidden");

      const currentScrollY =
        window.scrollY;


      if (currentScrollY <= 10) {

        header.classList.remove(
          "header-hidden"
        );

      }

      else if (
        currentScrollY >
        lastScrollY +
        scrollTolerance
      ) {

        header.classList.add(
          "header-hidden"
        );

      }

      else if (
        currentScrollY <
        lastScrollY -
        scrollTolerance
      ) {

        header.classList.remove(
          "header-hidden"
        );

      }


      lastScrollY =
        currentScrollY;

      ticking = false;

    }


    window.addEventListener(
      "scroll",
      function () {

        if (!ticking) {

          window.requestAnimationFrame(
            updateHeader
          );

          ticking = true;

        }

      },
      {
        passive: true
      }
    );


    updateHeader();

  }


  /* =====================================================
     SCROLL REVEAL
     ===================================================== */

  const revealSelectors = [

    ".section-head",
    ".grid > *",
    ".starbox",
    ".split > *",
    ".service-row",
    ".beat-row",
    ".need-row",
    ".subscription-card",
    ".process-step",
    ".media-frame",
    ".photo-slot",
    ".about-gallery-item",
    ".contact-intro",
    ".contact-form",
    ".section-actions",
    ".beat-genre",
    ".beat-page-row",
    ".genre-tabs",
    ".productgrid > *"

  ];


  let revealIndex = 0;


  revealSelectors.forEach(
    function (selector) {

      document
        .querySelectorAll(selector)
        .forEach(
          function (element) {

            if (
              element.classList.contains(
                "scroll-reveal"
              )
            ) {

              return;

            }


            element.classList.add(
              "scroll-reveal"
            );


            const animationType =
              revealIndex % 3;


            if (animationType === 0) {

              element.classList.add(
                "reveal-left"
              );

            }

            else if (
              animationType === 1
            ) {

              element.classList.add(
                "reveal-right"
              );

            }

            else {

              element.classList.add(
                "reveal-bottom"
              );

            }


            const delayType =
              revealIndex % 4;


            if (delayType === 1) {

              element.classList.add(
                "scroll-delay-1"
              );

            }

            else if (delayType === 2) {

              element.classList.add(
                "scroll-delay-2"
              );

            }

            else if (delayType === 3) {

              element.classList.add(
                "scroll-delay-3"
              );

            }


            revealIndex++;

          }
        );

    }
  );


  const revealElements =
    document.querySelectorAll(
      ".scroll-reveal"
    );


  if (
    "IntersectionObserver" in window
  ) {

    const observer =
      new IntersectionObserver(

        function (
          entries,
          observer
        ) {

          entries.forEach(
            function (entry) {

              if (
                !entry.isIntersecting
              ) {

                return;

              }


              entry.target.classList.add(
                "is-visible"
              );


              observer.unobserve(
                entry.target
              );

            }
          );

        },

        {

          threshold: 0.12,

          rootMargin:
            "0px 0px -70px 0px"

        }

      );


    revealElements.forEach(
      function (element) {

        observer.observe(
          element
        );

      }
    );

  }

  else {

    revealElements.forEach(
      function (element) {

        element.classList.add(
          "is-visible"
        );

      }
    );

  }


  /* =====================================================
     BOTÓN VOLVER ARRIBA
     ===================================================== */

  const backTop =
    document.getElementById(
      "nuvora-back-top"
    );


  if (backTop) {

    backTop.addEventListener(
      "click",
      function () {

        window.scrollTo({

          top: 0,

          behavior: "smooth"

        });

      }
    );

  }

});